import React, {Component} from 'react'
import moment from 'moment'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'

import {Badge, Button, Col, DatePicker, Icon, Mentions, notification, Row, Select} from 'antd'
import _ from 'lodash'
import TaskList from '../../components/TasksManagement/TaskList'

class FullCalendarTaskManagement extends Component {
  state = {
  }

  render() {
    return (
      <React.Fragment>
        <PageHeaderWrapper title={'Task Management'}>
          <TaskList />
        </PageHeaderWrapper>
      </React.Fragment>
    )
  }
}

export default FullCalendarTaskManagement
